export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0030s_0000_Black-&-White-21.118c0725.png";